class CollectionFilters extends HTMLElement {
  static FILTER_TOGGLE_ANIMATION_MS = 300;
  static FILTER_TOGGLE_ANIMATION_MS_LEGACY = 600;
  static _toolbarSortDocumentBound = false;
  static _globalDrawerBound = false;

  constructor() {
    super();
    this._filterToggleAnimating = false;
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.toggleFilterDrawer = this.toggleFilterDrawer.bind(this);
  }

  connectedCallback() {
    if (this._isConnected) return;
    this._isConnected = true;

    this.accordionType = this.dataset.accordiontype;
    this.filterType = this.dataset.filtertype;
    this.filterParent = this.getFilterDrawerParent();
    this.filterForm = this.querySelector("form");
    this.quickshop = document.querySelector("quick-shop");

    const toggleBtns = this.querySelectorAll(".filter__toggle");
    toggleBtns.forEach((button) =>
      button.addEventListener("click", this.toggleFilterBlock.bind(this))
    );

    CollectionFilters.bindGlobalDrawerControls();

    if (this.filterType == "horizontal-filters") {
      if (!CollectionFilters._horizontalBodyClickBound) {
        CollectionFilters._horizontalBodyClickBound = true;
        document.body.addEventListener("click", (event) => {
          const instance = CollectionFilters.getInstance();
          instance?.onHorizontalFiltersBodyClick(event);
        });
      }

      const filterContainers = this.querySelectorAll(".filter__container");
      filterContainers.forEach((target) => {
        target.addEventListener("click", (event) => {
          event.stopPropagation();
        });
      });

      this.initToolbarSortDropdowns();
    }

    this.sortby_values = document.querySelectorAll(
      "[data-sortby] .sortby_options"
    );
    this.sortby_values.forEach((input) =>
      input.addEventListener("change", this.updateSortBy.bind(this))
    );

    this.pagination_value = document.querySelectorAll(
      "[data-custom-pagination] .pagination_value"
    );
    this.pagination_value.forEach((input) =>
      input.addEventListener("change", this.updatePagination.bind(this))
    );

    this.subCollectionLinks = document.querySelectorAll(
      "[data-subCollections] .collection-entry"
    );
    this.subCollectionLinks.forEach((link) =>
      link.addEventListener("click", this._manageSubCollections.bind(this))
    );

    if (this.filterParent && !this.filterParent.dataset.filterDrawerKeyupBound) {
      this.filterParent.dataset.filterDrawerKeyupBound = "true";
      this.filterParent.addEventListener("keyup", (event) => {
        if (event.code.toUpperCase() === "ESCAPE") {
          CollectionFilters.getInstance()?.closeFilterDrawerPanel();
        }
      });
    }

    this.debouncedOnSubmit = Utility.debounce((event) => {
      event.preventDefault();
      event.stopPropagation();
      this.onSubmitHandler(event);
      var selectedValue = document.querySelectorAll(
        'collection-filters [type="checkbox"]:checked'
      )?.length;
      if (selectedValue > 0) {
        document.querySelector("collection-filters [data-applyFilters] span") !=
        null
          ? (document.querySelector(
              "collection-filters [data-applyFilters] span"
            ).innerHTML = "(" + selectedValue + ")")
          : "";
      } else {
        document.querySelector("collection-filters [data-applyFilters] span") !=
        null
          ? (document.querySelector(
              "collection-filters [data-applyFilters] span"
            ).innerHTML = ``)
          : "";
      }
    }, 500);

    if (this.filterForm) {
      this.filterForm.addEventListener(
        "input",
        this.debouncedOnSubmit.bind(this)
      );
      this.filterForm.addEventListener(
        "submit",
        this.debouncedOnSubmit.bind(this)
      );
      window.addEventListener("popstate", this.onHistoryChange.bind(this));
    }

    const applyBtn = this.querySelector("[data-applyFilters]");
    if (applyBtn) {
      applyBtn.addEventListener("click", () => {
        this.filterForm.dispatchEvent(
          new Event("submit", { bubbles: true, cancelable: true })
        );
        setTimeout(() => {
          this.closeFilterDrawerPanel();
        }, 1000);
      });
    }

    const paginationLinks = document.querySelectorAll("[data-pagination]");
    paginationLinks.forEach((link) =>
      link.addEventListener("click", this._managePagination.bind(this))
    );

    this.bindActiveFilterButtonEvents();
    this.addAccessibilityAttributes(toggleBtns);
    this.colorOptionsStyling();
  }

  /**
   * Filter Block Toggle event
   * @param {NodeList} toggleBtns Open filter block buttons
   */
  getFilterContainer(toggleBtn) {
    return toggleBtn.closest(".filter__container");
  }

  getFilterContentBlock(filterContainer) {
    if (!filterContainer) return null;
    return (
      filterContainer.querySelector('[data-type="content"]') ||
      filterContainer.querySelector(".filter__block.toggle-content") ||
      filterContainer.querySelector(".toggle-content")
    );
  }

  static getInstance() {
    return document.querySelector("collection-filters");
  }

  static bindGlobalDrawerControls() {
    if (CollectionFilters._globalDrawerBound) return;
    CollectionFilters._globalDrawerBound = true;

    document.addEventListener("click", (event) => {
      const opener = event.target.closest("#filter-drawer, #sortby-drawer");
      const closer = event.target.closest(".collection-filters-close");

      if (!opener && !closer) return;

      const instance = CollectionFilters.getInstance();
      if (!instance) return;

      if (opener) {
        event.preventDefault();
        instance.openFilterDrawerPanel(opener);
        return;
      }

      if (
        closer &&
        instance.getFilterDrawerParent()?.classList.contains("filter-active")
      ) {
        event.preventDefault();
        instance.closeFilterDrawerPanel();
      }
    });
  }

  getFilterDrawerParent() {
    return (
      this.filterParent ||
      document.getElementById("filtersCollapse") ||
      this.closest("#filtersCollapse")
    );
  }

  usesHorizontalFilterTransition() {
    return (
      this.filterType === "horizontal-filters" &&
      window.matchMedia("(min-width: 992px)").matches
    );
  }

  onHorizontalFiltersBodyClick(event) {
    if (
      event.target.closest(
        ".collection-toolbar-desktop custom-select.sortby-dropdown"
      ) ||
      event.target.closest(
        ".collection-grid-footer__per-page custom-select.sortby-dropdown"
      )
    ) {
      return;
    }

    this.closeToolbarDropdowns();
  }

  isFilterBlockOpen(filterContainer) {
    if (!filterContainer) return false;
    if (this.usesHorizontalFilterTransition()) {
      return !!this.getFilterContentBlock(filterContainer)?.classList.contains(
        "is-visible"
      );
    }
    return (
      filterContainer.classList.contains("open") ||
      !!filterContainer.querySelector("fieldset.open") ||
      !!filterContainer.querySelector(".filter__block.open")
    );
  }

  openHorizontalFilterBlock(toggleFilterBtn, filterContainer) {
    const contentBlock = this.getFilterContentBlock(filterContainer);
    if (!contentBlock) return;

    filterContainer.classList.add("open");
    contentBlock.classList.add("open");
    toggleFilterBtn.setAttribute("aria-expanded", true);
    contentBlock.style.height = "";

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        contentBlock.classList.add("is-visible");
      });
    });

    Utility.trapFocus(filterContainer);
  }

  closeHorizontalFilterBlock(toggleFilterBtn, filterContainer) {
    const contentBlock = this.getFilterContentBlock(filterContainer);
    if (!contentBlock) return Promise.resolve();

    const duration = CollectionFilters.FILTER_TOGGLE_ANIMATION_MS;
    let finished = false;

    const finish = () => {
      if (finished) return;
      finished = true;
      contentBlock.classList.remove("is-visible", "open");
      filterContainer.classList.remove("open");
      toggleFilterBtn.setAttribute("aria-expanded", false);
      contentBlock.style.height = "";
      filterContainer.querySelector("fieldset.open")?.classList.remove("open");
      Utility.removeTrapFocus(filterContainer);
    };

    return new Promise((resolve) => {
      if (!this.isFilterBlockOpen(filterContainer)) {
        resolve();
        return;
      }

      toggleFilterBtn.setAttribute("aria-expanded", false);

      const done = () => {
        finish();
        resolve();
      };

      const onTransitionEnd = (event) => {
        if (event.target !== contentBlock || event.propertyName !== "opacity")
          return;
        contentBlock.removeEventListener("transitionend", onTransitionEnd);
        done();
      };

      contentBlock.addEventListener("transitionend", onTransitionEnd);
      contentBlock.classList.remove("is-visible");

      setTimeout(() => {
        contentBlock.removeEventListener("transitionend", onTransitionEnd);
        done();
      }, duration + 50);
    });
  }

  addAccessibilityAttributes(toggleBtns) {
    toggleBtns.forEach((element) => {
      const filterContainer = this.getFilterContainer(element);
      const contentBlock =
        filterContainer?.querySelector('[data-type="content"]') ||
        filterContainer?.querySelector(".toggle-content");
      const isButton = element.tagName === "BUTTON";

      if (!isButton) {
        element.setAttribute("role", "button");
      }

      element.setAttribute(
        "aria-expanded",
        this.isFilterBlockOpen(filterContainer) ? "true" : "false"
      );

      if (contentBlock?.id) {
        element.setAttribute("aria-controls", contentBlock.id);
      }
    });
  }

  /**
   * Collection filter form Input event
   * @param {event} event Event Instance
   */
  onSubmitHandler(event) {
    event.preventDefault();
    if (
      event.type == "input" &&
      this.getFilterDrawerParent()?.classList.contains("filter-active")
    ) {
      return;
    }

    let closestForm = document.getElementById("CollectionFiltersForm");
    if (event.target && event.target.closest("form")) {
      closestForm = event.target.closest("form");
    }
    if (!closestForm) return;

    let searchParams;
    // When only sort was changed, preserve current URL params and only update sort_by.
    // This prevents default price filter values (e.g. range slider min/max) from being applied.
    if (event.target && event.target.name === "sort_by") {
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set("sort_by", event.target.value);
      searchParams = currentUrl.searchParams.toString();
    } else {
      const isPriceChange =
        event.target &&
        event.target.name &&
        event.target.name.indexOf("filter.v.price") >= 0;
      searchParams = this._finalQueryString(closestForm, isPriceChange);
    }

    if (this.usesHorizontalFilterTransition()) {
      this.closeToolbarDropdowns();
    }

    this.renderPage(searchParams);
  }

  /**
   * click event To Remove current selections
   * @param {element} form Collection page filter form
   */
  _finalQueryString(form, includePrice = false) {
    const formData = new FormData(form);
    const params = new URLSearchParams();
    let constraints = "";
    formData.forEach((val, key) => {
      // Exclude price filter params unless the user explicitly changed the price filter
      if (!includePrice && key && key.indexOf("filter.v.price") >= 0) {
        return;
      }
      if (key.indexOf("price-list") >= 0) {
        new URLSearchParams(String(val)).forEach((v, k) => {
          params.append(k, v);
        });
      } else if (key.indexOf("custom_sort_by") >= 0) {
        //  Code for SortBy
      } else if (key.indexOf("tagsFilter-") > -1) {
        if (constraints === "") {
          constraints = val;
        } else {
          constraints += `+${val}`;
        }
      } else if (val != null && String(val).length > 0) {
        params.append(key, val);
      }
    });

    if (constraints !== "") {
      params.set("constraint", constraints);
    }

    return params.toString();
  }

  /**
   * Add background color in label of Color options
   */
  colorOptionsStyling() {
    const colorSwatchContainer = this.querySelector("[data-colorFilter]");
    if (colorSwatchContainer) {
      const colorSwatches =
        colorSwatchContainer.querySelectorAll(".color-options");
      colorSwatches.forEach((swatch) => {
        let colorHandle = swatch.querySelector('input[type="checkbox"]').dataset
          .handle;
        let swatchStyle = Utility.getSwatchStyle(colorHandle);
        swatch
          .querySelector(".option-label")
          .setAttribute("style", swatchStyle);
      });
    }
  }

  /**
   * click event To Remove current selections
   * @param {event} event Event Instance
   */
  onActiveFilterClick(event) {
    event.preventDefault();
    event.stopPropagation();
    let currentTarget = event.target;
    let URLString = null;
    if (currentTarget.dataset.type == "tag_based") {
      const inputValue = currentTarget.dataset.remove;
      const inputElement = document.querySelector(
        `input[data-tagslist][value="${inputValue}"]`
      );
      if (inputElement) inputElement.checked = false;

      let closestForm = document.getElementById("CollectionFiltersForm");
      if (!closestForm) return;
      URLString = this._finalQueryString(closestForm);
    } else {
      if (
        event.target
          .closest(".filter-option-clear")
          .classList.contains("filter-option-clear")
      ) {
        currentTarget = event.target.closest(".filter-option-clear");
        URLString = new URL(currentTarget.href).searchParams.toString();
      }
    }
    if (URLString != null) this.renderPage(URLString);
  }

  /**
   * Update Window URL as per active filters
   * @param {event} event Event Instance
   */
  onHistoryChange(event) {
    const searchParams = event.state?.searchParams || "";
    this.renderPage(searchParams, false);
  }

  /**
   *
   * @param {String} searchParams Query Parameters
   * @param {String} updateURLHash true/false
   */
  renderPage(searchParams, updateURLHash = true) {
    document
      .getElementById("collection-product-grid")
      .querySelector("#template-collection")
      .classList.add("loading");
    const url = `${window.location.pathname}?${searchParams}`;
    this.renderGridFromFetch(url, "filter");
    if (updateURLHash) this.updateURLHash(searchParams);
  }

  /**
   *
   * @param {String} url URL for fetching results
   * @param {String} type filter / pagination / sub_collection_filter
   */
  renderGridFromFetch(url, type) {
    document.querySelector("#collection-product-grid")?.scrollIntoView();
    if (!url) return;
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        this.renderProductGrid(html, type);
      });
  }

  /**
   *
   * @param {HTMlResponse} html
   * @param {String} type filter / pagination / sub_collection_filter
   */
  renderProductGrid(html, type) {
    const innerHTML = new DOMParser().parseFromString(html, "text/html");
    // We have used individuals components replacement code because of load more feature
    let paginationType = "numbers";
    if (document.querySelector("[data-pagination]")) {
      paginationType =
        document.querySelector("[data-pagination]").dataset.type || "numbers";
    }
    if (type == "filter" || type == "sub_collection_filter") {
      const gridHTML = innerHTML.getElementById(
        "collection-product-grid"
      ).innerHTML;
      document.getElementById("collection-product-grid").innerHTML = gridHTML;

      if (type == "sub_collection_filter") {
        let bannerHTML = innerHTML.querySelector(
          "[data-collectionBanner]"
        ).innerHTML;
        document.querySelector("[data-collectionBanner]").innerHTML =
          bannerHTML;
      }
    } else {
      if (paginationType == "loadmore") {
        let productGrids = innerHTML.getElementById(
          "template-collection"
        ).innerHTML;
        let loadMoreBtn = innerHTML.getElementById("load-more");
        document
          .getElementById("template-collection")
          .insertAdjacentHTML("beforeend", productGrids);
        if (loadMoreBtn && document.getElementById("load-more")) {
          document
            .getElementById("load-more")
            .parentNode.replaceChild(
              loadMoreBtn,
              document.getElementById("load-more")
            );
        } else if (document.getElementById("load-more")) {
          document.getElementById("load-more").remove();
        }
      } else {
        const gridHTML = innerHTML.getElementById(
          "collection-product-grid"
        ).innerHTML;
        document.getElementById("collection-product-grid").innerHTML = gridHTML;
      }
    }

    const openFilters = document.querySelectorAll(".filter__container.open");
    const filterInnerHTML = innerHTML.getElementById(
      "main-collection-filters"
    ).innerHTML;
    document.getElementById("main-collection-filters").innerHTML =
      filterInnerHTML;

    const collectionFilters = CollectionFilters.getInstance();

    if (
      (type === "filter" || type === "sub_collection_filter") &&
      collectionFilters?.usesHorizontalFilterTransition()
    ) {
      collectionFilters.closeToolbarDropdowns();
    } else {
      openFilters.forEach((openFilter) => {
        const filterBlock = document.querySelector(
          '.filter__container[data-index="' + openFilter.dataset.index + '"]'
        );
        const toggle = filterBlock?.querySelector(".filter__toggle");
        if (!filterBlock || !toggle) return;

        collectionFilters?.openDrawerFilterBlock(toggle, filterBlock);
      });
    }

    const filterContainers = document.querySelectorAll(".filter__container");
    filterContainers.forEach((filter) => {
      const tagList = filter.querySelectorAll(".filter__item");
      if (tagList.length <= 0) {
        filter.classList.add("d-none");
        filter.style.display = "none";
      }
    });

    const totalProducts = innerHTML.querySelector("[data-totalProducts]");
    if (totalProducts) {
      document.querySelectorAll("[data-totalProducts]").forEach((element) => {
        element.innerHTML = totalProducts.innerHTML;
      });
    }

    const activeFilters = innerHTML.querySelector("[data-activeFilters]");
    if (activeFilters)
      document.querySelector("[data-activeFilters]").innerHTML =
        activeFilters.innerHTML;
    this.bindActiveFilterButtonEvents();
    this.bindCollectionFooterEvents();
    if (this.quickshop) {
      this.quickshop.updateEvents();
    }

    // execute window function for modal opening after collection filtering.
    window.reExecuteOpener();
    // execute window function for all notify me function which coming from the app
    window.SwymCallbacks.push(swymCallbackFn);
    // execute collection js file to reinit the view more button of the filter.
    new templateCollectionJS();

    // reinit wishlist
    var allWishlistSelector = document.querySelectorAll("[data-product-grid]");
    if (allWishlistSelector.length > 0) {
      allWishlistSelector.forEach((item) => {
        var pId = item.getAttribute("data-product-grid");
        window._swat.initializeActionButtons(
          `[data-product-grid="${pId}"]`,
          "[data-swaction]"
        );
      });
    }
  }

  /**
   * Re-Binding events on active filters after ajax request
   */
  bindActiveFilterButtonEvents() {
    document.querySelectorAll(".filter-option-clear").forEach((element) => {
      element.addEventListener("click", this.onActiveFilterClick, {
        once: true,
      });
    });
  }

  bindCollectionFooterEvents() {
    document
      .querySelectorAll("#collection-product-grid a[data-pagination]")
      .forEach((link) => {
        link.addEventListener("click", this._managePagination.bind(this), {
          once: true,
        });
      });

    document
      .querySelectorAll(
        "#collection-product-grid [data-custom-pagination] .pagination_value"
      )
      .forEach((input) => {
        input.addEventListener("change", this.updatePagination.bind(this), {
          once: true,
        });
      });
  }

  /**
   * Update the url
   * @param {String} searchParams
   */
  updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
    );
  }

  /**
   *
   * @param {event} event
   */
  updateSortBy(event) {
    let _this = event.currentTarget;
    let currentvalue = document.querySelector(
      '[data-sortby] [name="custom_sort_by_mobile"]:checked'
    ).value;
    if (_this.name == "custom_sort_by_desktop") {
      currentvalue = document.querySelector(
        '[data-sortby] [name="custom_sort_by_desktop"]:checked'
      ).value;
    }

    document.querySelector('[name="sort_by"]').value = currentvalue;
    document.querySelector('[name="sort_by"]').dispatchEvent(
      new Event("input", {
        bubbles: true,
        cancelable: true,
      })
    );
  }

  /**
   *
   * @param {event} event
   */
  updatePagination(event) {
    event.preventDefault();
    let _this = event.currentTarget;
    let currentvalue = document.querySelector(
      '[data-custom-pagination] [type="radio"]:checked'
    ).value;

    this.querySelector('[name="count"]').value = currentvalue;
    this.querySelector('[name="count"]').dispatchEvent(
      new Event("input", {
        bubbles: true,
        cancelable: true,
      })
    );
  }
  /**
   *
   * @param {event} event
   */
  _manageSubCollections(event) {
    event.preventDefault();
    const _this = event.currentTarget;
    let closestForm = document.getElementById("CollectionFiltersForm");
    if (_this.closest("form")) {
      closestForm = event.target.closest("form");
    }
    const queryString = this._finalQueryString(closestForm);

    let collURL = _this.href + "?" + queryString;
    this.renderGridFromFetch(collURL, "sub_collection_filter");
    setTimeout(() => {
      history.pushState({}, "", collURL);
    }, 500);
  }

  /**
   *
   * @param {event} event
   */
  _managePagination(event) {
    event.preventDefault();
    let _this = event.currentTarget;
    var nextPageLink = _this.href;
    var product_count = parseInt(
      event.target
        .closest("[data-pagination_bar]")
        ?.getAttribute("data-pagination_bar")
    );
    if (
      nextPageLink &&
      nextPageLink.includes("?") &&
      nextPageLink.includes("=")
    ) {
      nextPageLink = nextPageLink + `&count=${product_count}`;
    }
    this.renderGridFromFetch(nextPageLink, "pagination");

    setTimeout(() => {
      history.pushState({}, "", nextPageLink);
    }, 500);
  }

  static getHorizontalFiltersInstance() {
    return document.querySelector(
      'collection-filters[data-filtertype="horizontal-filters"]'
    );
  }

  getToolbarSortDropdowns() {
    return document.querySelectorAll(
      ".collection-toolbar-desktop custom-select.sortby-dropdown:not(.custom-pagination-dropdown)"
    );
  }

  isSortDropdownOpen(selectEl) {
    const content = selectEl?.querySelector(".custom--select .toggle-content");
    return content?.classList.contains("is-visible");
  }

  hasOpenSortDropdown() {
    return Array.from(this.getToolbarSortDropdowns()).some((select) =>
      this.isSortDropdownOpen(select)
    );
  }

  closeSortDropdown(selectEl) {
    const panel = selectEl?.querySelector(".custom--select");
    const content = panel?.querySelector(".toggle-content");
    if (!content || !this.isSortDropdownOpen(selectEl)) {
      return Promise.resolve();
    }

    const duration = CollectionFilters.FILTER_TOGGLE_ANIMATION_MS;
    let finished = false;

    const finish = () => {
      if (finished) return;
      finished = true;
      content.classList.remove("is-visible", "open");
      panel?.classList.remove("open");
      selectEl.classList.remove("open");
      content.style.height = "";
      selectEl.querySelector(".default")?.setAttribute("aria-expanded", "false");
    };

    return new Promise((resolve) => {
      const done = () => {
        finish();
        resolve();
      };

      const onTransitionEnd = (event) => {
        if (event.target !== content || event.propertyName !== "opacity") return;
        content.removeEventListener("transitionend", onTransitionEnd);
        done();
      };

      content.addEventListener("transitionend", onTransitionEnd);
      content.classList.remove("is-visible");

      setTimeout(() => {
        content.removeEventListener("transitionend", onTransitionEnd);
        done();
      }, duration + 50);
    });
  }

  closeAllSortDropdowns() {
    const closePromises = [];
    this.getToolbarSortDropdowns().forEach((select) => {
      closePromises.push(this.closeSortDropdown(select));
    });
    return Promise.all(closePromises);
  }

  openSortDropdown(selectEl) {
    const panel = selectEl?.querySelector(".custom--select");
    const content = panel?.querySelector(".toggle-content");
    if (!content) return;

    panel.classList.add("open");
    content.classList.add("open");
    selectEl.classList.add("open");
    content.style.height = "";
    selectEl.querySelector(".default")?.setAttribute("aria-expanded", "true");

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        content.classList.add("is-visible");
      });
    });
  }

  closeToolbarDropdowns() {
    this.closeOtherFilterBlocks();
    return this.closeAllSortDropdowns();
  }

  initToolbarSortDropdowns() {
    if (CollectionFilters._toolbarSortDocumentBound) return;
    CollectionFilters._toolbarSortDocumentBound = true;

    document.addEventListener(
      "click",
      async (event) => {
        const collectionFilters = CollectionFilters.getHorizontalFiltersInstance();
        if (!collectionFilters?.usesHorizontalFilterTransition()) return;

        const trigger = event.target.closest(
          ".collection-toolbar-desktop custom-select.sortby-dropdown:not(.custom-pagination-dropdown) .default"
        );
        if (!trigger) return;

        const selectEl = trigger.closest("custom-select.sortby-dropdown");
        if (!selectEl) return;

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        if (collectionFilters._filterToggleAnimating) return;

        const isOpen = collectionFilters.isSortDropdownOpen(selectEl);
        const duration = CollectionFilters.FILTER_TOGGLE_ANIMATION_MS;
        const hasOpenFilters = Array.from(
          collectionFilters.querySelectorAll(".filter__container")
        ).some((container) => collectionFilters.isFilterBlockOpen(container));
        const needsSequence =
          !isOpen && (hasOpenFilters || collectionFilters.hasOpenSortDropdown());

        collectionFilters._filterToggleAnimating = true;

        if (!isOpen) {
          await Promise.all([
            collectionFilters.closeOtherFilterBlocks(),
            collectionFilters.closeAllSortDropdowns(),
          ]);
          collectionFilters.openSortDropdown(selectEl);
        } else {
          await collectionFilters.closeSortDropdown(selectEl);
        }

        setTimeout(() => {
          collectionFilters._filterToggleAnimating = false;
        }, needsSequence ? duration * 2 : duration);
      },
      true
    );

    this.getToolbarSortDropdowns().forEach((selectEl) => {
      selectEl.addEventListener("click", (event) => {
        event.stopPropagation();
      });

      const content = selectEl.querySelector(".custom--select .toggle-content");
      content?.classList.remove("is-visible", "open");
      selectEl.querySelector(".custom--select")?.classList.remove("open");
      selectEl.classList.remove("open");
      selectEl.querySelector(".default")?.setAttribute("aria-expanded", "false");
    });
  }

  /**
   * Toggle Filter drawer
   * @param {event} event
   */
  closeOtherFilterBlocks(currentContainer) {
    const scope =
      currentContainer?.closest(".filter__wrapper") ||
      this.querySelector(".filter__wrapper") ||
      this;
    const closePromises = [];
    scope.querySelectorAll(".filter__container").forEach((element) => {
      if (element === currentContainer || !this.isFilterBlockOpen(element))
        return;
      const toggle = element.querySelector(".filter__toggle");
      if (toggle) closePromises.push(this.closeFilterBlock(toggle));
    });
    return Promise.all(closePromises);
  }

  toggleFilterDrawer(event) {
    event.preventDefault();
    const button = event.currentTarget;

    if (button.id == "filter-drawer" || button.id == "sortby-drawer") {
      this.openFilterDrawerPanel(button);
    } else {
      this.closeFilterDrawerPanel();
    }
  }

  openFilterDrawerPanel(button) {
    const filterParent = this.getFilterDrawerParent();
    if (!filterParent || !button) return;

    this.filterParent = filterParent;
    this.closeToolbarDropdowns();
    filterParent.classList.add("filter-active");
    button.setAttribute("aria-expanded", "true");
    button.setAttribute("tabindex", "-1");

    if (button.id == "sortby-drawer") {
      filterParent.classList.add("sortby-drawer");
    } else {
      filterParent.classList.remove("sortby-drawer");
    }

    const closeControl = filterParent.querySelector(
      ".collection-filters-close button, .collection-filters-close"
    );
    Utility.trapFocus(filterParent);
    if (closeControl) Utility.forceFocus(closeControl);

    if (document.getElementById("site-overlay")) {
      siteOverlay.prototype.showOverlay();
    }
  }

  closeFilterDrawerPanel() {
    const filterParent = this.getFilterDrawerParent();
    if (!filterParent) return;

    filterParent.classList.remove("filter-active", "sortby-drawer");

    const openFilterDrawer = document.getElementById("filter-drawer");
    const openSortbyDrawer = document.getElementById("sortby-drawer");

    if (openFilterDrawer) {
      openFilterDrawer.setAttribute("aria-expanded", "false");
      openFilterDrawer.removeAttribute("tabindex");
    }
    if (openSortbyDrawer) {
      openSortbyDrawer.setAttribute("aria-expanded", "false");
      openSortbyDrawer.removeAttribute("tabindex");
    }

    Utility.removeTrapFocus(filterParent);

    if (document.getElementById("site-overlay")) {
      siteOverlay.prototype.hideOverlay();
    }
  }

  /**
   * Toggle Filter drawer
   * @param {event} event
   */
  toggleFilterBlock(event) {
    event.preventDefault();
    event.stopPropagation();
    if (this._filterToggleAnimating) return;

    const toggleFilterBtn = event.currentTarget;
    const filterContainer = this.getFilterContainer(toggleFilterBtn);
    if (!filterContainer) return;

    if (this.isFilterBlockOpen(filterContainer)) {
      this._filterToggleAnimating = true;
      this.closeFilterBlock(toggleFilterBtn).then(() => {
        this._filterToggleAnimating = false;
      });
    } else {
      this.openFilterBlock(toggleFilterBtn);
    }
  }

  hasOtherOpenFilterBlocks(filterContainer) {
    const scope =
      filterContainer.closest(".filter__wrapper") ||
      this.querySelector(".filter__wrapper") ||
      this;
    return Array.from(scope.querySelectorAll(".filter__container")).some(
      (element) =>
        element !== filterContainer && this.isFilterBlockOpen(element)
    );
  }

  /**
   * Open Filter Block
   * @param {element} toggleFilterBtn
   */
  async openFilterBlock(toggleFilterBtn) {
    if (this._filterToggleAnimating) return;

    const filterContainer = this.getFilterContainer(toggleFilterBtn);
    if (!filterContainer) return;

    const shouldCloseOthers =
      this.filterType === "horizontal-filters" ||
      this.accordionType === "single";
    const hasOpenOthers =
      shouldCloseOthers && this.hasOtherOpenFilterBlocks(filterContainer);
    const hasOpenSort = this.usesHorizontalFilterTransition() && this.hasOpenSortDropdown();
    const { FILTER_TOGGLE_ANIMATION_MS: duration } = CollectionFilters;
    const needsSequence = hasOpenOthers || hasOpenSort;
    const unlockDelay = needsSequence ? duration * 2 : duration;

    this._filterToggleAnimating = true;

    if (needsSequence) {
      await Promise.all([
        this.closeAllSortDropdowns(),
        hasOpenOthers
          ? this.closeOtherFilterBlocks(filterContainer)
          : Promise.resolve(),
      ]);
    }

    if (this.usesHorizontalFilterTransition()) {
      this.openHorizontalFilterBlock(toggleFilterBtn, filterContainer);
    } else {
      this.openDrawerFilterBlock(toggleFilterBtn, filterContainer);
    }

    setTimeout(() => {
      this._filterToggleAnimating = false;
    }, unlockDelay);
  }

  /**
   * Close Filter Block
   * @param {element} toggleFilterBtn
   */
  closeFilterBlock(toggleFilterBtn) {
    const filterContainer = this.getFilterContainer(toggleFilterBtn);
    if (!filterContainer || !this.isFilterBlockOpen(filterContainer)) {
      return Promise.resolve();
    }

    if (this.usesHorizontalFilterTransition()) {
      return this.closeHorizontalFilterBlock(toggleFilterBtn, filterContainer);
    }

    this.closeDrawerFilterBlock(toggleFilterBtn, filterContainer);
    return Promise.resolve();
  }

  openDrawerFilterBlock(toggleFilterBtn, filterContainer) {
    const contentBlock = this.getFilterContentBlock(filterContainer);
    if (!contentBlock) return;

    toggleFilterBtn.setAttribute("aria-expanded", true);
    filterContainer.classList.add("open");
    contentBlock.classList.add("open");
    contentBlock.style.height = "";
    filterContainer.querySelector("fieldset")?.classList.add("open");
    Utility.trapFocus(filterContainer);
  }

  closeDrawerFilterBlock(toggleFilterBtn, filterContainer) {
    const contentBlock = this.getFilterContentBlock(filterContainer);

    toggleFilterBtn.setAttribute("aria-expanded", false);
    filterContainer.classList.remove("open");
    contentBlock?.classList.remove("open");
    if (contentBlock) contentBlock.style.height = "";
    filterContainer.querySelector("fieldset.open")?.classList.remove("open");
    Utility.removeTrapFocus(filterContainer);
  }
}

customElements.define("collection-filters", CollectionFilters);

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((element) =>
      element.addEventListener("change", this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }

  /**
   *
   * @param {event} event
   */
  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("min", 0);
    if (maxInput.value === "")
      minInput.setAttribute("max", maxInput.getAttribute("max"));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("min"));
    const max = Number(input.getAttribute("max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}
customElements.define("price-range", PriceRange);

class PriceRangeSlider extends HTMLElement {
  constructor() {
    super();

    let _this = this;
    let sliderSections = this.getElementsByClassName("range-slider");
    for (const element of sliderSections) {
      let sliders = element.getElementsByTagName("input");
      for (const element of sliders) {
        if (element.type === "range") {
          element.oninput = _this.getVals;
          element.oninput();
        }
      }
    }
  }

  getVals() {
    const parent = this.closest(".price-filter__slider, .range-slider");
    if (!parent) return;

    const slides = parent.querySelectorAll('input[type="range"]');
    if (slides.length < 2) return;

    let slide1 = parseFloat(slides[0].value);
    let slide2 = parseFloat(slides[1].value);
    const slidemax = parseFloat(slides[1].max) || 1;

    if (slide1 > slide2) {
      const tmp = slide2;
      slide2 = slide1;
      slide1 = tmp;
    }

    const rangemove = parent.querySelector(".rangeslider");
    if (rangemove) {
      rangemove.style.left = (slide1 * 100) / slidemax + "%";
      rangemove.style.width =
        (slide2 * 100) / slidemax - (slide1 * 100) / slidemax + "%";
    }

    const displayElement = parent.querySelector(".rangeValues");
    if (!displayElement) return;

    const minFormatted = Shopify.formatMoney(
      slide1 * 100,
      window.globalVariables.money_format
    );
    const maxFormatted = Shopify.formatMoney(
      slide2 * 100,
      window.globalVariables.money_format
    );

    displayElement.innerHTML = `
      <span class="price-filter__value border border-indigo-dye-300 rounded-pill px-2 py-1">${minFormatted}</span>
      <span class="price-filter__separator text-indigo-dye-300 font-size-sm mx-1">to</span>
      <span class="price-filter__value border border-indigo-dye-300 rounded-pill px-2 py-1">${maxFormatted}</span>
    `;
  }
}
customElements.define("range-slider", PriceRangeSlider);
